import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import type { PageWipeProps, PageWipeRef } from './PageWipe.data';
import styles from './PageWipe.module.scss';
import { setupTransitionInTimeline, setupTransitionOutTimeline } from './PageWipe.transitions';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import { useGlobalStore } from '../../../stores/global';

function PageWipe({ className, ref }: PageWipeProps & { ref?: Ref<PageWipeRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;
  const { showPageWipeEffect } = useGlobalStore();

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  useChangeTransitionState(transitionController, {
    onMount: false,
    value: showPageWipeEffect,
  });

  return <div ref={elementRef} className={classNames(styles.pageWipe, className)}></div>;
}
export default observer(PageWipe);
